import { checkout_free_url, checkout_paid_url } from "../../../config";
import log from "../../../utils/log";

export default async function redirectToPayfortAsync(params) {
  log("redirectToPayfortAsync", "request", params);

  return new Promise((resolve) => {
    if (Number(params.amount) === 0) {
      post(checkout_free_url, params);
    } else {
      post(checkout_paid_url, params);
    }

    // keep loading-indicator displayed for few seconds
    setTimeout(() => resolve(true), 10000);
  });
}

const post = (path, params, method = "post") => {
  const form = document.createElement("form");
  form.method = method;
  form.action = path;
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = key;
      hiddenField.value = params[key];

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
};
